module.exports = "/_next/static/images/f0ba742afb52a94fb9a355e6f362d08e-bill-close_day.png";